import { compose } from 'redux'
import { connect } from 'react-redux'

const mapStateToProps = (state, props) => {
    return {};
};

export default compose(
    connect(mapStateToProps, {  })

);


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Gant/components/GantComponent/GantComponent.enhancer.js